import type { Theme } from '@emotion/react'
import { Tag, Text } from '@moia-dev/pace-web'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const ARROW_UP = '\u2191'
const ARROW_DOWN = '\u2193'
const COMMAND = '\u2318'
const RETURN = '\u23CE'

type FooterHintProps = {
  label: string
  children: ReactNode
}

const FooterHint = ({ label, children }: FooterHintProps) => (
  <div
    css={(theme: Theme) => ({
      display: 'flex',
      alignItems: 'center',
      gap: theme.space.Space1,
    })}
  >
    {children}
    <Text
      size="sm"
      color="reduced"
      css={(theme: Theme) => ({
        marginLeft: theme.space.Space1,
      })}
    >
      {label}
    </Text>
  </div>
)

const isMac = () => navigator.platform.toUpperCase().includes('MAC')

export const CommandPaletteFooter = () => {
  const { t } = useTranslation()

  return (
    <div
      css={(theme: Theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.space.Space5,
      })}
    >
      <div
        css={(theme: Theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: theme.space.Space4,
        })}
      >
        <FooterHint label={t('commandPalette_footer_navigate')}>
          <Tag label={ARROW_UP} />
          <Tag label={ARROW_DOWN} />
        </FooterHint>
        <FooterHint label={t('commandPalette_footer_select')}>
          <Tag label={RETURN} />
        </FooterHint>
        <FooterHint label={t('commandPalette_footer_close')}>
          <Tag label="Esc" />
        </FooterHint>
      </div>
      <FooterHint label={t('commandPalette_footer_openHint')}>
        <Tag label={`${isMac() ? COMMAND : 'Ctrl'} + K`} />
      </FooterHint>
    </div>
  )
}
